import React from 'react';
import { RouteComponentProps } from 'react-router';
import { FortunaListContainer } from '../../epic/fortuna-list';

export const Page: React.FC<RouteComponentProps> = () => {
  return <FortunaListContainer />;
};
